import { render } from "./CursorComponent.vue?vue&type=template&id=3bd005e7"
import script from "./CursorComponent.vue?vue&type=script&lang=js"
export * from "./CursorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__